import React, { useState } from 'react';
import { ArrowLeft, AlertTriangle, CheckCircle, Clock, Eye, Edit, Upload, ExternalLink, MessageSquare, User, Calendar, Shield, FileText, Link as LinkIcon, Flag, Check, X, RotateCcw, PenTool, AlertCircle, ChevronDown, Bot, Send, Copy, Download, GitBranch, Zap, Target, DollarSign, Save, Plus, Trash2, Image, File, ChevronUp, Wine, Percent, InfoIcon, Sparkles, Activity, ChevronLeft, ChevronRight } from 'lucide-react';
import { WorkflowStepper } from '../components/WorkflowStepper';
import { AiAssistant } from '../components/AiAssistant';
export function LabelReview() {
  const [selectedVersion, setSelectedVersion] = useState('v1.3');
  const [activeTab, setActiveTab] = useState('details');
  const [isEditingDraft, setIsEditingDraft] = useState(false);
  const [draftText, setDraftText] = useState('2023 Napa Valley Cabernet Sauvignon');
  const [isEditingUsedOn, setIsEditingUsedOn] = useState(false);
  const [usedOnPlatforms, setUsedOnPlatforms] = useState(['Front Label', 'Back Label', 'Website']);
  const [newLink, setNewLink] = useState('');
  const [showAddLink, setShowAddLink] = useState(false);
  const [currentLabelView, setCurrentLabelView] = useState(0);
  const [showAdditionalText, setShowAdditionalText] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([{
    id: 1,
    name: 'TTB_Form_5100.31.pdf',
    type: 'pdf',
    size: '1.8 MB',
    uploadedBy: 'Maria Vasquez',
    uploadedAt: '2023-10-14'
  }, {
    id: 2,
    name: 'label_design_draft.jpg',
    type: 'image',
    size: '3.5 MB',
    uploadedBy: 'Design Team',
    uploadedAt: '2023-10-12'
  }, {
    id: 3,
    name: 'lab_analysis.pdf',
    type: 'pdf',
    size: '1.2 MB',
    uploadedBy: 'Quality Control',
    uploadedAt: '2023-10-10'
  }]);
  const [supportingLinks, setSupportingLinks] = useState([{
    id: 1,
    url: 'https://www.ttb.gov/wine/wine-labeling',
    title: 'TTB Wine Labeling Guidelines',
    addedBy: 'Legal Team',
    addedAt: '2023-10-09'
  }, {
    id: 2,
    url: 'https://www.sonomawine.com/appellations',
    title: 'Sonoma County Appellation Information',
    addedBy: 'Winemaker',
    addedAt: '2023-10-08'
  }]);
  const availablePlatforms = ['Front Label', 'Back Label', 'Website', 'Marketing materials', 'Neck tag', 'Case packaging', 'Shelf talker', 'Tasting notes', 'Wine club materials'];
  // Label preview images (front and back)
  const labelPreviews = [{
    name: 'Front Label',
    component: <div className="relative w-48 h-64 bg-purple-50 rounded-lg overflow-hidden border border-purple-100" data-id="element-321">
          <div className="absolute inset-0 flex flex-col" data-id="element-322">
            <div className="flex-1 flex flex-col items-center justify-center p-4 text-center" data-id="element-323">
              <div className="w-16 h-16 mb-2 mx-auto rounded-full bg-purple-600 flex items-center justify-center" data-id="element-324">
                <span className="text-white font-bold text-xs" data-id="element-325">SCOOP</span>
              </div>
              <h5 className="text-xs font-bold text-purple-700 mb-1" data-id="element-326">
                SCOOP ESTATE
              </h5>
              <p className="text-[10px] font-medium mb-2" data-id="element-327">2023</p>
              <h4 className="text-sm font-bold mb-1" data-id="element-328">CABERNET SAUVIGNON</h4>
              <p className="text-[10px]" data-id="element-329">NAPA VALLEY</p>
              <div className="mt-auto text-[8px] text-gray-600" data-id="element-330">
                750ML • 14.2% ALC/VOL
              </div>
            </div>
          </div>
        </div>
  }, {
    name: 'Back Label',
    component: <div className="relative w-48 h-64 bg-purple-50 rounded-lg overflow-hidden border border-purple-100" data-id="element-331">
          <div className="absolute inset-0 flex flex-col p-3" data-id="element-332">
            <div className="flex-1 flex flex-col text-center" data-id="element-333">
              <h5 className="text-[10px] font-bold text-purple-700 mb-1" data-id="element-334">
                SCOOP ESTATE
              </h5>
              <p className="text-[8px] mb-2 text-gray-700" data-id="element-335">
                Our Napa Valley Cabernet Sauvignon is crafted from hand-selected
                grapes grown in our estate vineyards. This wine exhibits rich
                flavors of blackberry, dark chocolate, and subtle oak with a
                long, elegant finish.
              </p>
              <div className="text-[6px] text-gray-600 mb-1 text-left" data-id="element-336">
                GOVERNMENT WARNING: (1) According to the Surgeon General, women
                should not drink alcoholic beverages during pregnancy because of
                the risk of birth defects. (2) Consumption of alcoholic
                beverages impairs your ability to drive a car or operate
                machinery, and may cause health problems.
              </div>
              <div className="text-[6px] text-gray-600 text-left" data-id="element-337">
                CONTAINS SULFITES • PRODUCED AND BOTTLED BY SCOOP VINEYARDS, ST.
                HELENA, CA • 750ML • 14.2% ALC/VOL
              </div>
            </div>
          </div>
        </div>
  }];
  const label = {
    id: 'WL-2023-0042',
    title: '2023 Napa Valley Cabernet Sauvignon',
    type: 'Wine Label',
    status: 'review',
    priority: 'high',
    riskLevel: 'medium',
    currentVersion: 'v1.3',
    lastModified: {
      user: 'Maria Vasquez',
      role: 'Marketing',
      date: '2023-10-15',
      time: '3:45 PM'
    }
  };
  const versions = [{
    version: 'v1.3',
    text: '2023 Napa Valley Cabernet Sauvignon',
    status: 'current',
    date: '2023-10-15'
  }, {
    version: 'v1.2',
    text: '2023 Sonoma Valley Cabernet Sauvignon',
    status: 'draft',
    date: '2023-10-14'
  }, {
    version: 'v1.1',
    text: '2023 California Cabernet Sauvignon',
    status: 'flagged',
    date: '2023-10-12'
  }, {
    version: 'v1.0',
    text: '2023 Cabernet Sauvignon',
    status: 'created',
    date: '2023-10-10'
  }];
  // Reversed timeline - latest first
  const timeline = [{
    id: 4,
    version: 'v1.3',
    action: 'Revised Draft',
    user: 'Maria Vasquez',
    role: 'Marketing',
    date: '2023-10-15',
    time: '3:45 PM',
    comment: 'Updated appellation to Napa Valley per winemaker notes',
    status: 'current'
  }, {
    id: 3,
    version: 'v1.2',
    action: 'Updated Draft',
    user: 'Maria Vasquez',
    role: 'Marketing',
    date: '2023-10-14',
    time: '11:30 AM',
    comment: 'Changed appellation from California to Sonoma Valley',
    status: 'updated'
  }, {
    id: 2,
    version: 'v1.1',
    action: 'Compliance Issue',
    user: 'Legal Team',
    role: 'Compliance',
    date: '2023-10-12',
    time: '9:15 AM',
    comment: 'Appellation required for TTB compliance',
    status: 'flagged'
  }, {
    id: 1,
    version: 'v1.0',
    action: 'Created',
    user: 'Maria Vasquez',
    role: 'Marketing',
    date: '2023-10-10',
    time: '2:30 PM',
    comment: 'Initial wine label draft for 2023 Cabernet',
    status: 'created'
  }];
  // Wine details
  const wineDetails = {
    brandName: 'Scoop Estate',
    vintage: '2023',
    varietal: 'Cabernet Sauvignon',
    appellation: 'Napa Valley',
    alcoholContent: '14.2%',
    bottleVolume: '750ml',
    healthWarning: 'GOVERNMENT WARNING: (1) According to the Surgeon General, women should not drink alcoholic beverages during pregnancy because of the risk of birth defects. (2) Consumption of alcoholic beverages impairs your ability to drive a car or operate machinery, and may cause health problems.',
    containsSulfites: true,
    producedBy: 'Scoop Vineyards, St. Helena, CA',
    importedBy: 'N/A - Domestic Product',
    ttbId: 'TTB-ID-19283746',
    additionalText: {
      frontLabel: ['SCOOP ESTATE', '2023', 'CABERNET SAUVIGNON', 'NAPA VALLEY', '750ML • 14.2% ALC/VOL'],
      backLabel: ['SCOOP ESTATE', 'Our Napa Valley Cabernet Sauvignon is crafted from hand-selected grapes grown in our estate vineyards. This wine exhibits rich flavors of blackberry, dark chocolate, and subtle oak with a long, elegant finish.', 'GOVERNMENT WARNING: (1) According to the Surgeon General, women should not drink alcoholic beverages during pregnancy because of the risk of birth defects. (2) Consumption of alcoholic beverages impairs your ability to drive a car or operate machinery, and may cause health problems.', 'CONTAINS SULFITES • PRODUCED AND BOTTLED BY SCOOP VINEYARDS, ST. HELENA, CA • 750ML • 14.2% ALC/VOL']
    }
  };
  // Products
  const products = [{
    id: 'CAB-NV-23-750',
    name: '2023 Napa Valley Cabernet Sauvignon',
    type: 'Wine',
    status: 'Active',
    platforms: ['Tasting Room', 'Website', 'Distribution'],
    image: 'https://placehold.co/80x80',
    blendInfo: {
      isBlend: true,
      components: [{
        varietal: 'Cabernet Sauvignon',
        percentage: 80
      }, {
        varietal: 'Merlot',
        percentage: 15
      }, {
        varietal: 'Petit Verdot',
        percentage: 5
      }]
    }
  }, {
    id: 'CAB-NV-23-1500',
    name: '2023 Napa Valley Cabernet Sauvignon Magnum',
    type: 'Wine',
    status: 'Active',
    platforms: ['Tasting Room', 'Wine Club'],
    image: 'https://placehold.co/80x80',
    blendInfo: {
      isBlend: true,
      components: [{
        varietal: 'Cabernet Sauvignon',
        percentage: 80
      }, {
        varietal: 'Merlot',
        percentage: 15
      }, {
        varietal: 'Petit Verdot',
        percentage: 5
      }]
    }
  }, {
    id: 'CAB-NV-23-CASE',
    name: '2023 Napa Valley Cabernet Sauvignon Case',
    type: 'Package',
    status: 'Active',
    platforms: ['Website', 'Distribution'],
    image: 'https://placehold.co/80x80'
  }];
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'conflict':
      case 'flagged':
        return <AlertTriangle className="w-5 h-5 text-amber-600" data-id="element-338" />;
      case 'current':
        return <CheckCircle className="w-5 h-5 text-green-600" data-id="element-339" />;
      case 'created':
        return <User className="w-5 h-5 text-blue-600" data-id="element-340" />;
      default:
        return <Clock className="w-5 h-5 text-gray-600" data-id="element-341" />;
    }
  };
  const getRiskColor = (risk: string) => {
    switch (risk) {
      case 'high':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'medium':
        return 'bg-amber-100 text-amber-800 border-amber-200';
      case 'low':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'pdf':
        return <FileText className="w-4 h-4 text-red-600" data-id="element-342" />;
      case 'image':
        return <Image className="w-4 h-4 text-blue-600" data-id="element-343" />;
      default:
        return <File className="w-4 h-4 text-gray-600" data-id="element-344" />;
    }
  };
  const saveDraft = () => {
    setIsEditingDraft(false);
    console.log('Saving draft:', draftText);
  };
  const togglePlatform = (platform: string) => {
    if (usedOnPlatforms.includes(platform)) {
      setUsedOnPlatforms(usedOnPlatforms.filter(p => p !== platform));
    } else {
      setUsedOnPlatforms([...usedOnPlatforms, platform]);
    }
  };
  const saveUsedOn = () => {
    setIsEditingUsedOn(false);
    console.log('Saving used on platforms:', usedOnPlatforms);
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      Array.from(files).forEach(file => {
        const newFile = {
          id: uploadedFiles.length + 1,
          name: file.name,
          type: file.type.includes('image') ? 'image' : file.type.includes('pdf') ? 'pdf' : 'file',
          size: `${(file.size / 1024 / 1024).toFixed(1)} MB`,
          uploadedBy: 'Maria Vasquez',
          uploadedAt: new Date().toISOString().split('T')[0]
        };
        setUploadedFiles([...uploadedFiles, newFile]);
      });
    }
  };
  const addLink = () => {
    if (newLink.trim()) {
      const link = {
        id: supportingLinks.length + 1,
        url: newLink,
        title: newLink.length > 50 ? newLink.substring(0, 50) + '...' : newLink,
        addedBy: 'Maria Vasquez',
        addedAt: new Date().toISOString().split('T')[0]
      };
      setSupportingLinks([...supportingLinks, link]);
      setNewLink('');
      setShowAddLink(false);
    }
  };
  const removeFile = (id: number) => {
    setUploadedFiles(uploadedFiles.filter(file => file.id !== id));
  };
  const removeLink = (id: number) => {
    setSupportingLinks(supportingLinks.filter(link => link.id !== id));
  };
  const nextLabelView = () => {
    setCurrentLabelView(prev => (prev + 1) % labelPreviews.length);
  };
  const prevLabelView = () => {
    setCurrentLabelView(prev => (prev - 1 + labelPreviews.length) % labelPreviews.length);
  };
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-345">
      <WorkflowStepper data-id="element-346" />
      {/* Page Header */}
      <div className="bg-white border-b border-gray-200" data-id="element-347">
        <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-348">
          {/* Breadcrumb */}
          <div className="flex items-center space-x-2 mb-4 text-sm text-gray-600" data-id="element-349">
            <button className="hover:text-gray-900" data-id="element-350">Labels</button>
            <span data-id="element-351">›</span>
            <span className="text-purple-700 font-medium" data-id="element-352">{label.id}</span>
          </div>
          <div className="flex items-start justify-between" data-id="element-353">
            <div className="flex-1" data-id="element-354">
              <div className="flex items-center space-x-4 mb-3" data-id="element-355">
                <button className="flex items-center space-x-2 text-gray-600 hover:text-gray-900" data-id="element-356">
                  <ArrowLeft className="w-4 h-4" data-id="element-357" />
                  <span data-id="element-358">Back to Labels</span>
                </button>
              </div>
              <div className="flex items-center space-x-3 mb-4" data-id="element-359">
                <span className="bg-amber-100 text-amber-800 border border-amber-200 px-3 py-1 rounded-full text-sm font-medium" data-id="element-360">
                  REVIEW
                </span>
                <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getRiskColor(label.riskLevel)}`} data-id="element-361">
                  {label.riskLevel.toUpperCase()} RISK
                </span>
                <span className="bg-purple-100 text-purple-700 border border-purple-200 px-3 py-1 rounded-full text-sm font-medium" data-id="element-362">
                  {label.type.toUpperCase()}
                </span>
              </div>
              {/* Version Selector */}
              <div className="flex items-center space-x-4" data-id="element-363">
                <div className="relative" data-id="element-364">
                  <select value={selectedVersion} onChange={e => setSelectedVersion(e.target.value)} className="appearance-none bg-white border border-gray-200 rounded-lg px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-365">
                    {versions.map(version => <option key={version.version} value={version.version} data-id="element-366">
                        {version.version} -{' '}
                        {version.status === 'current' ? 'Current Draft' : version.status}
                      </option>)}
                  </select>
                  <ChevronDown className="w-4 h-4 absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-367" />
                </div>
                <span className="text-sm text-gray-600" data-id="element-368">
                  Last modified by {label.lastModified.user} -{' '}
                  {label.lastModified.date}, {label.lastModified.time}
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-3" data-id="element-369">
              <button className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 flex items-center space-x-2" data-id="element-370">
                <X className="w-4 h-4" data-id="element-371" />
                <span data-id="element-372">Reject</span>
              </button>
              <button className="bg-purple-700 text-white px-4 py-2 rounded-lg hover:bg-purple-800 flex items-center space-x-2" data-id="element-373">
                <Check className="w-4 h-4" data-id="element-374" />
                <span data-id="element-375">Approve</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <main className="max-w-7xl mx-auto px-6 py-6" data-id="element-376">
        <div className="grid grid-cols-10 gap-6" data-id="element-377">
          {/* Main Content - 70% width */}
          <div className="col-span-7 space-y-6" data-id="element-378">
            {/* Tabs */}
            <div className="bg-white rounded-lg border" data-id="element-379">
              <div className="border-b border-gray-200" data-id="element-380">
                <nav className="flex -mb-px" data-id="element-381">
                  <button onClick={() => setActiveTab('details')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'details' ? 'border-purple-700 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-382">
                    Label Details
                  </button>
                  <button onClick={() => setActiveTab('products')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'products' ? 'border-purple-700 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-383">
                    Product
                  </button>
                  <button onClick={() => setActiveTab('activity')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'activity' ? 'border-purple-700 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-384">
                    Timeline & Activity
                  </button>
                  <button onClick={() => setActiveTab('attachments')} className={`py-4 px-6 inline-flex items-center border-b-2 font-medium text-sm ${activeTab === 'attachments' ? 'border-purple-700 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-385">
                    Attachments
                  </button>
                </nav>
              </div>
              <div className="p-6" data-id="element-386">
                {/* Details Tab */}
                {activeTab === 'details' && <div className="space-y-6" data-id="element-387">
                    {/* Current Draft Panel */}
                    <div className="border-b border-gray-200 pb-6" data-id="element-388">
                      <div className="flex items-center justify-between mb-4" data-id="element-389">
                        <div className="flex items-center space-x-2" data-id="element-390">
                          <Wine className="w-5 h-5 text-purple-700" data-id="element-391" />
                          <h3 className="text-lg font-semibold text-gray-900" data-id="element-392">
                            Current Label Draft
                          </h3>
                          <span className="bg-purple-100 text-purple-700 text-xs px-2 py-1 rounded-full" data-id="element-393">
                            v1.3
                          </span>
                        </div>
                        {!isEditingDraft && <button onClick={() => setIsEditingDraft(true)} className="flex items-center space-x-1 px-3 py-1.5 text-purple-700 hover:text-purple-800 border border-purple-700 rounded-lg hover:bg-purple-50 text-sm" data-id="element-394">
                            <Edit className="w-4 h-4" data-id="element-395" />
                            <span data-id="element-396">Edit</span>
                          </button>}
                      </div>
                      {/* Current draft content - Rearranged to match screenshot layout */}
                      <div className="grid grid-cols-2 gap-6" data-id="element-397">
                        <div className="space-y-6" data-id="element-398">
                          <div data-id="element-399">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-400">
                              Brand Name
                            </label>
                            {isEditingDraft ? <input type="text" value={wineDetails.brandName} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-401" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-402">
                                {wineDetails.brandName}
                              </div>}
                          </div>
                          <div className="grid grid-cols-2 gap-4" data-id="element-403">
                            <div data-id="element-404">
                              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-405">
                                Vintage
                              </label>
                              {isEditingDraft ? <input type="text" value={wineDetails.vintage} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-406" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-407">
                                  {wineDetails.vintage}
                                </div>}
                            </div>
                            <div data-id="element-408">
                              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-409">
                                Varietal
                              </label>
                              {isEditingDraft ? <input type="text" value={wineDetails.varietal} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-410" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-411">
                                  {wineDetails.varietal}
                                </div>}
                            </div>
                          </div>
                          <div data-id="element-412">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-413">
                              Appellation
                            </label>
                            {isEditingDraft ? <input type="text" value={wineDetails.appellation} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-414" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-415">
                                {wineDetails.appellation}
                              </div>}
                          </div>
                          <div className="grid grid-cols-2 gap-4" data-id="element-416">
                            <div data-id="element-417">
                              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-418">
                                Alcohol Content
                              </label>
                              {isEditingDraft ? <div className="relative" data-id="element-419">
                                  <input type="text" value={wineDetails.alcoholContent} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-420" />
                                  <Percent className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-421" />
                                </div> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-422">
                                  {wineDetails.alcoholContent}
                                </div>}
                            </div>
                            <div data-id="element-423">
                              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-424">
                                Bottle Volume
                              </label>
                              {isEditingDraft ? <input type="text" value={wineDetails.bottleVolume} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-425" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-426">
                                  {wineDetails.bottleVolume}
                                </div>}
                            </div>
                          </div>
                        </div>
                        <div className="space-y-6" data-id="element-427">
                          <div className="flex items-start space-x-2" data-id="element-428">
                            <div className="pt-1" data-id="element-429">
                              {isEditingDraft ? <input type="checkbox" checked={wineDetails.containsSulfites} className="rounded border-gray-300 text-purple-700 focus:ring-purple-500 h-4 w-4" data-id="element-430" /> : <div className="w-5 h-5 rounded bg-purple-700 flex items-center justify-center" data-id="element-431">
                                  <Check className="w-4 h-4 text-white" data-id="element-432" />
                                </div>}
                            </div>
                            <div data-id="element-433">
                              <label className="block text-sm font-medium text-gray-700" data-id="element-434">
                                Contains Sulfites
                              </label>
                              <p className="text-xs text-gray-500" data-id="element-435">
                                Required for wines containing 10+ ppm of sulfur
                                dioxide
                              </p>
                            </div>
                          </div>
                          <div data-id="element-436">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-437">
                              Produced By
                            </label>
                            {isEditingDraft ? <input type="text" value={wineDetails.producedBy} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-438" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-439">
                                {wineDetails.producedBy}
                              </div>}
                          </div>
                          <div data-id="element-440">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-441">
                              Imported By (if applicable)
                            </label>
                            {isEditingDraft ? <input type="text" value={wineDetails.importedBy} placeholder="Leave blank if domestic" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" data-id="element-442" /> : <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200" data-id="element-443">
                                {wineDetails.importedBy}
                              </div>}
                          </div>
                          <div data-id="element-444">
                            <div className="flex items-center justify-between" data-id="element-445">
                              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-446">
                                TTB ID
                              </label>
                              <span className="text-xs text-purple-700" data-id="element-447">
                                TTB Tracking Number
                              </span>
                            </div>
                            <div className="text-gray-900 font-medium p-2 bg-gray-50 rounded-lg border border-gray-200 flex items-center space-x-2" data-id="element-448">
                              <FileText className="w-4 h-4 text-purple-700" data-id="element-449" />
                              <span data-id="element-450">{wineDetails.ttbId}</span>
                            </div>
                          </div>
                          {/* Health Warning moved to bottom and grayed out */}
                          <div data-id="element-451">
                            <label className="block text-sm font-medium text-gray-500 mb-1" data-id="element-452">
                              Health Warning (Required)
                            </label>
                            <div className="text-gray-500 text-sm p-2 bg-gray-100 rounded-lg border border-gray-200" data-id="element-453">
                              {wineDetails.healthWarning}
                            </div>
                            <p className="text-xs text-gray-400 mt-1" data-id="element-454">
                              Standard government warning text (non-editable)
                            </p>
                          </div>
                        </div>
                      </div>
                      {isEditingDraft && <div className="mt-4 flex items-center space-x-2" data-id="element-455">
                          <button onClick={saveDraft} className="bg-purple-700 text-white px-4 py-2 rounded-lg hover:bg-purple-800 flex items-center space-x-2 text-sm" data-id="element-456">
                            <Save className="w-4 h-4" data-id="element-457" />
                            <span data-id="element-458">Save Draft</span>
                          </button>
                          <button onClick={() => setIsEditingDraft(false)} className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 text-sm" data-id="element-459">
                            Cancel
                          </button>
                        </div>}
                      <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-3" data-id="element-460">
                        <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-461" />
                        <div data-id="element-462">
                          <h4 className="font-medium text-red-800" data-id="element-463">
                            Appellation Compliance Issue
                          </h4>
                          <p className="text-sm text-red-700" data-id="element-464">
                            The Napa Valley appellation requires at least 85% of
                            grapes from the region. Current blend shows only 80%
                            Cabernet Sauvignon from Napa Valley, which does not
                            meet requirements.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                {/* Products Tab - Now showing blend information */}
                {activeTab === 'products' && <div className="space-y-6" data-id="element-465">
                    <div className="grid grid-cols-1 gap-4" data-id="element-466">
                      {products.map(product => <div key={product.id} className="flex items-start space-x-4 p-4 border border-gray-200 rounded-lg hover:bg-gray-50" data-id="element-467">
                          <img src={product.image} alt={product.name} className="w-20 h-20 rounded-lg object-cover" data-id="element-468" />
                          <div className="flex-1 min-w-0" data-id="element-469">
                            <div className="flex items-start justify-between" data-id="element-470">
                              <div data-id="element-471">
                                <h4 className="text-sm font-medium text-gray-900" data-id="element-472">
                                  {product.name}
                                </h4>
                                <p className="text-sm text-gray-500" data-id="element-473">
                                  {product.id}
                                </p>
                              </div>
                              <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${product.type === 'Wine' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-474">
                                {product.type}
                              </span>
                            </div>
                            <div className="mt-2" data-id="element-475">
                              <p className="text-sm text-gray-600" data-id="element-476">
                                Sold via: {product.platforms.join(', ')}
                              </p>
                            </div>
                            <div className="mt-2 flex items-center space-x-4" data-id="element-477">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-478">
                                {product.status}
                              </span>
                            </div>
                            {/* Blend information with compliance warning */}
                            {product.blendInfo && product.blendInfo.isBlend && <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg" data-id="element-479">
                                <div className="flex items-center mb-2" data-id="element-480">
                                  <AlertTriangle className="w-4 h-4 text-red-600 mr-2" data-id="element-481" />
                                  <h5 className="text-sm font-medium text-red-800" data-id="element-482">
                                    Blend Composition - Compliance Issue
                                  </h5>
                                </div>
                                <div className="space-y-1" data-id="element-483">
                                  {product.blendInfo.components.map((component, idx) => <div key={idx} className="flex justify-between text-sm" data-id="element-484">
                                        <span className="text-gray-700" data-id="element-485">
                                          {component.varietal}
                                        </span>
                                        <span className={`font-medium ${component.varietal === 'Cabernet Sauvignon' ? 'text-red-600' : 'text-gray-700'}`} data-id="element-486">
                                          {component.percentage}%
                                        </span>
                                      </div>)}
                                </div>
                                <p className="mt-2 text-xs text-red-600" data-id="element-487">
                                  <AlertCircle className="w-3 h-3 inline mr-1" data-id="element-488" />
                                  Napa Valley appellation requires at least 85%
                                  grapes from the region. Current blend (80%)
                                  does not meet requirements.
                                </p>
                              </div>}
                          </div>
                        </div>)}
                    </div>
                  </div>}
                {/* Activity Tab */}
                {activeTab === 'activity' && <div className="space-y-6" data-id="element-489">
                    {/* Next Step */}
                    <div className="flex items-start space-x-4" data-id="element-490">
                      <div className="flex-shrink-0 mt-1" data-id="element-491">
                        <div className="w-10 h-10 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center" data-id="element-492">
                          <Clock className="w-5 h-5 text-gray-400" data-id="element-493" />
                        </div>
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-494">
                        <div className="flex items-center space-x-2 mb-1" data-id="element-495">
                          <span className="font-medium text-gray-600" data-id="element-496">
                            Next: Pending TTB Compliance Review
                          </span>
                        </div>
                        <p className="text-sm text-gray-500" data-id="element-497">
                          Awaiting review from regulatory compliance team
                        </p>
                      </div>
                    </div>
                    {/* Timeline items */}
                    {timeline.map((item, index) => <div key={item.id} className="flex items-start space-x-4" data-id="element-498">
                        <div className="flex-shrink-0 mt-1" data-id="element-499">
                          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${item.status === 'created' ? 'bg-blue-100' : item.status === 'flagged' ? 'bg-amber-100' : item.status === 'updated' ? 'bg-yellow-100' : 'bg-green-100'}`} data-id="element-500">
                            {getStatusIcon(item.status)}
                          </div>
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-501">
                          <div className="flex items-center space-x-2 mb-1" data-id="element-502">
                            <span className="font-medium text-gray-900" data-id="element-503">
                              {item.version}
                            </span>
                            <span className="text-sm text-gray-600" data-id="element-504">
                              - {item.action}
                            </span>
                            <span className="text-xs text-gray-500" data-id="element-505">
                              by {item.user} ({item.role})
                            </span>
                          </div>
                          <p className="text-sm text-gray-700 mb-2" data-id="element-506">
                            {item.comment}
                          </p>
                          <div className="flex items-center space-x-2 text-xs text-gray-500" data-id="element-507">
                            <span data-id="element-508">{item.date}</span>
                            <span data-id="element-509">•</span>
                            <span data-id="element-510">{item.time}</span>
                          </div>
                        </div>
                        {index < timeline.length - 1 && <div className="absolute left-11 mt-12 w-px h-8 bg-gray-200" data-id="element-511" />}
                      </div>)}
                  </div>}
                {/* Attachments Tab */}
                {activeTab === 'attachments' && <div className="space-y-6" data-id="element-512">
                    {/* File Upload */}
                    <div className="mb-4" data-id="element-513">
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-gray-400 transition-colors" data-id="element-514">
                        <Upload className="w-6 h-6 text-gray-400 mx-auto mb-2" data-id="element-515" />
                        <p className="text-sm text-gray-600 mb-2" data-id="element-516">
                          Upload TTB forms, certificates, label designs, or
                          other documentation
                        </p>
                        <input type="file" multiple onChange={handleFileUpload} className="hidden" id="file-upload" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" data-id="element-517" />
                        <label htmlFor="file-upload" className="bg-purple-700 text-white px-4 py-2 rounded-lg hover:bg-purple-800 cursor-pointer text-sm" data-id="element-518">
                          Choose Files
                        </label>
                      </div>
                    </div>
                    {/* Uploaded Files */}
                    <div className="mb-4" data-id="element-519">
                      <h5 className="text-sm font-medium text-gray-700 mb-2" data-id="element-520">
                        Uploaded Files
                      </h5>
                      <div className="space-y-2" data-id="element-521">
                        {uploadedFiles.map(file => <div key={file.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-522">
                            <div className="flex items-center space-x-3" data-id="element-523">
                              {getFileIcon(file.type)}
                              <div data-id="element-524">
                                <p className="text-sm font-medium text-gray-900" data-id="element-525">
                                  {file.name}
                                </p>
                                <p className="text-xs text-gray-500" data-id="element-526">
                                  {file.size} • Uploaded by {file.uploadedBy} on{' '}
                                  {file.uploadedAt}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2" data-id="element-527">
                              <button className="text-blue-600 hover:text-blue-700" data-id="element-528">
                                <Eye className="w-4 h-4" data-id="element-529" />
                              </button>
                              <button onClick={() => removeFile(file.id)} className="text-red-600 hover:text-red-700" data-id="element-530">
                                <Trash2 className="w-4 h-4" data-id="element-531" />
                              </button>
                            </div>
                          </div>)}
                      </div>
                    </div>
                    {/* Reference Links */}
                    <div data-id="element-532">
                      <div className="flex items-center justify-between mb-2" data-id="element-533">
                        <h5 className="text-sm font-medium text-gray-700" data-id="element-534">
                          Reference Links
                        </h5>
                        <button onClick={() => setShowAddLink(!showAddLink)} className="flex items-center space-x-1 text-purple-700 hover:text-purple-800 text-sm" data-id="element-535">
                          <Plus className="w-4 h-4" data-id="element-536" />
                          <span data-id="element-537">Add Link</span>
                        </button>
                      </div>
                      {showAddLink && <div className="mb-3 p-3 border border-gray-200 rounded-lg bg-gray-50" data-id="element-538">
                          <div className="flex space-x-2" data-id="element-539">
                            <input type="url" value={newLink} onChange={e => setNewLink(e.target.value)} placeholder="Enter URL (TTB guidelines, appellation info, etc.)" className="flex-1 p-2 text-sm border border-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-540" />
                            <button onClick={addLink} className="bg-purple-700 text-white px-3 py-2 rounded hover:bg-purple-800 text-sm" data-id="element-541">
                              Add
                            </button>
                            <button onClick={() => setShowAddLink(false)} className="bg-gray-500 text-white px-3 py-2 rounded hover:bg-gray-600 text-sm" data-id="element-542">
                              Cancel
                            </button>
                          </div>
                        </div>}
                      {/* Supporting Links */}
                      <div className="space-y-2" data-id="element-543">
                        {supportingLinks.map(link => <div key={link.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-544">
                            <div className="flex items-center space-x-3" data-id="element-545">
                              <LinkIcon className="w-4 h-4 text-blue-600" data-id="element-546" />
                              <div data-id="element-547">
                                <p className="text-sm font-medium text-gray-900" data-id="element-548">
                                  {link.title}
                                </p>
                                <p className="text-xs text-gray-500" data-id="element-549">
                                  Added by {link.addedBy} on {link.addedAt}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2" data-id="element-550">
                              <button className="text-blue-600 hover:text-blue-700" data-id="element-551">
                                <ExternalLink className="w-4 h-4" data-id="element-552" />
                              </button>
                              <button onClick={() => removeLink(link.id)} className="text-red-600 hover:text-red-700" data-id="element-553">
                                <Trash2 className="w-4 h-4" data-id="element-554" />
                              </button>
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
          {/* Right Sidebar - 30% width */}
          <div className="col-span-3 space-y-6" data-id="element-555">
            {/* Label Preview - Now with navigation controls */}
            <div className="bg-white rounded-lg border" data-id="element-556">
              <div className="p-4 border-b border-gray-200" data-id="element-557">
                <div className="flex items-center justify-between" data-id="element-558">
                  <h3 className="font-semibold text-gray-900" data-id="element-559">
                    Label Preview
                    <span className="ml-2 text-xs text-gray-500" data-id="element-560">
                      ({currentLabelView === 0 ? 'Front' : 'Back'})
                    </span>
                  </h3>
                  <button className="text-purple-700 hover:text-purple-800 text-sm" data-id="element-561">
                    View Full Size
                  </button>
                </div>
              </div>
              <div className="p-4 flex flex-col items-center" data-id="element-562">
                {labelPreviews[currentLabelView].component}
                {/* Navigation controls */}
                <div className="flex items-center justify-between w-full mt-4" data-id="element-563">
                  <button onClick={prevLabelView} className="flex items-center space-x-1 text-purple-700 hover:text-purple-800 text-sm" data-id="element-564">
                    <ChevronLeft className="w-4 h-4" data-id="element-565" />
                    <span data-id="element-566">
                      {currentLabelView === 1 ? 'Front Label' : 'Back Label'}
                    </span>
                  </button>
                  <div className="flex space-x-1" data-id="element-567">
                    {labelPreviews.map((_, index) => <div key={index} className={`w-2 h-2 rounded-full ${currentLabelView === index ? 'bg-purple-700' : 'bg-gray-300'}`} data-id="element-568" />)}
                  </div>
                  <button onClick={nextLabelView} className="flex items-center space-x-1 text-purple-700 hover:text-purple-800 text-sm" data-id="element-569">
                    <span data-id="element-570">
                      {currentLabelView === 0 ? 'Back Label' : 'Front Label'}
                    </span>
                    <ChevronRight className="w-4 h-4" data-id="element-571" />
                  </button>
                </div>
              </div>
              {/* Label Text Section */}
              <div className="border-t border-gray-200 p-4" data-id="element-572">
                <div className="flex items-center justify-between mb-2" data-id="element-573">
                  <h3 className="font-medium text-gray-900" data-id="element-574">Label Text</h3>
                  <button onClick={() => setShowAdditionalText(!showAdditionalText)} className="text-purple-700 hover:text-purple-800 text-sm flex items-center" data-id="element-575">
                    {showAdditionalText ? 'Hide' : 'Show'} All Text
                    {showAdditionalText ? <ChevronUp className="w-4 h-4 ml-1" data-id="element-576" /> : <ChevronDown className="w-4 h-4 ml-1" data-id="element-577" />}
                  </button>
                </div>
                {showAdditionalText && <div className="mt-2 space-y-4" data-id="element-578">
                    <div data-id="element-579">
                      <h4 className="text-xs font-medium text-gray-700 mb-1" data-id="element-580">
                        Front Label Text:
                      </h4>
                      <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-581">
                        <ul className="space-y-1 text-sm text-gray-700" data-id="element-582">
                          {wineDetails.additionalText.frontLabel.map((line, index) => <li key={index} data-id="element-583">{line}</li>)}
                        </ul>
                      </div>
                    </div>
                    <div data-id="element-584">
                      <h4 className="text-xs font-medium text-gray-700 mb-1" data-id="element-585">
                        Back Label Text:
                      </h4>
                      <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-586">
                        <ul className="space-y-2 text-sm text-gray-700" data-id="element-587">
                          {wineDetails.additionalText.backLabel.map((line, index) => <li key={index} className={index === 2 ? 'text-xs text-gray-500' : ''} data-id="element-588">
                                {line}
                              </li>)}
                        </ul>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
            {/* TTB Compliance Checklist - Updated with appellation warning */}
            <div className="bg-white rounded-lg border" data-id="element-589">
              <div className="p-4 border-b border-gray-200" data-id="element-590">
                <div className="flex items-center justify-between" data-id="element-591">
                  <div className="flex items-center space-x-2" data-id="element-592">
                    <Shield className="w-5 h-5 text-purple-700" data-id="element-593" />
                    <h3 className="font-semibold text-gray-900" data-id="element-594">
                      TTB Compliance Checklist
                    </h3>
                  </div>
                  <div className="flex items-center space-x-1 bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs" data-id="element-595">
                    <Sparkles className="w-3 h-3" data-id="element-596" />
                    <span data-id="element-597">Scoop AI</span>
                  </div>
                </div>
              </div>
              <div className="p-4" data-id="element-598">
                <ul className="space-y-3" data-id="element-599">
                  <li className="flex items-start space-x-2" data-id="element-600">
                    <div className="mt-0.5" data-id="element-601">
                      <Check className="w-4 h-4 text-green-600" data-id="element-602" />
                    </div>
                    <div data-id="element-603">
                      <p className="text-sm font-medium text-gray-900" data-id="element-604">
                        Brand Name
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-605">
                        Properly displayed and registered
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-606">
                    <div className="mt-0.5" data-id="element-607">
                      <Check className="w-4 h-4 text-green-600" data-id="element-608" />
                    </div>
                    <div data-id="element-609">
                      <p className="text-sm font-medium text-gray-900" data-id="element-610">
                        Class/Type Designation
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-611">
                        Cabernet Sauvignon meets 75% varietal requirement
                      </p>
                    </div>
                  </li>
                  {/* Highlighted appellation issue for blend */}
                  <li className="flex items-start space-x-2 bg-red-50 p-2 rounded-lg border border-red-200" data-id="element-612">
                    <div className="mt-0.5" data-id="element-613">
                      <X className="w-4 h-4 text-red-600" data-id="element-614" />
                    </div>
                    <div data-id="element-615">
                      <p className="text-sm font-medium text-red-800" data-id="element-616">
                        Appellation
                      </p>
                      <p className="text-xs text-red-700" data-id="element-617">
                        <strong data-id="element-618">Compliance Issue:</strong> Napa Valley requires
                        85% of grapes from the region
                      </p>
                      <p className="text-xs text-red-600 mt-1" data-id="element-619">
                        Current blend shows only 80% - does not meet
                        requirements
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-620">
                    <div className="mt-0.5" data-id="element-621">
                      <Check className="w-4 h-4 text-green-600" data-id="element-622" />
                    </div>
                    <div data-id="element-623">
                      <p className="text-sm font-medium text-gray-900" data-id="element-624">
                        Alcohol Content
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-625">
                        14.2% ABV properly displayed
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-626">
                    <div className="mt-0.5" data-id="element-627">
                      <AlertTriangle className="w-4 h-4 text-amber-600" data-id="element-628" />
                    </div>
                    <div data-id="element-629">
                      <p className="text-sm font-medium text-gray-900" data-id="element-630">
                        Government Warning
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-631">
                        Required on back label - not yet verified
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-632">
                    <div className="mt-0.5" data-id="element-633">
                      <Check className="w-4 h-4 text-green-600" data-id="element-634" />
                    </div>
                    <div data-id="element-635">
                      <p className="text-sm font-medium text-gray-900" data-id="element-636">
                        Net Contents
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-637">
                        750ml properly displayed
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-638">
                    <div className="mt-0.5" data-id="element-639">
                      <Check className="w-4 h-4 text-green-600" data-id="element-640" />
                    </div>
                    <div data-id="element-641">
                      <p className="text-sm font-medium text-gray-900" data-id="element-642">
                        Contains Sulfites
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-643">
                        Declaration properly included
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {/* State Information Section */}
            <div className="bg-white rounded-lg border" data-id="element-644">
              <div className="p-4 border-b border-gray-200" data-id="element-645">
                <div className="flex items-center space-x-2" data-id="element-646">
                  <InfoIcon className="w-5 h-5 text-purple-700" data-id="element-647" />
                  <h3 className="font-semibold text-gray-900" data-id="element-648">
                    State Information
                  </h3>
                </div>
              </div>
              <div className="p-4 space-y-4" data-id="element-649">
                <div data-id="element-650">
                  <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-651">
                    Current State
                  </h4>
                  <div className="bg-purple-100 text-purple-800 px-3 py-2 rounded-lg text-sm flex items-center space-x-2" data-id="element-652">
                    <Activity className="w-4 h-4" data-id="element-653" />
                    <span data-id="element-654">Compliance Review</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-655">Type: review</p>
                </div>
                <div data-id="element-656">
                  <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-657">
                    Expected Next State
                  </h4>
                  <div className="bg-gray-100 text-gray-800 px-3 py-2 rounded-lg text-sm" data-id="element-658">
                    Legal Review
                  </div>
                </div>
              </div>
            </div>
            {/* Workflow Section */}
            <div className="bg-white rounded-lg border" data-id="element-659">
              <div className="p-4 border-b border-gray-200" data-id="element-660">
                <div className="flex items-center space-x-2" data-id="element-661">
                  <GitBranch className="w-5 h-5 text-purple-700" data-id="element-662" />
                  <h3 className="font-semibold text-gray-900" data-id="element-663">Workflow</h3>
                </div>
              </div>
              <div className="p-4" data-id="element-664">
                <p className="text-sm text-gray-800 mb-2" data-id="element-665">
                  Standard TTB Compliance Review Process
                </p>
                <div className="bg-purple-100 text-purple-700 text-xs px-2 py-1 rounded-full inline-block" data-id="element-666">
                  Active
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Floating AI Assistant */}
      <AiAssistant data-id="element-667" />
    </div>;
}